import { render, staticRenderFns } from "./Tests.vue?vue&type=template&id=3e0b97b4&scoped=true"
import script from "./Tests.vue?vue&type=script&lang=js"
export * from "./Tests.vue?vue&type=script&lang=js"
import style0 from "./Tests.vue?vue&type=style&index=0&id=3e0b97b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0b97b4",
  null
  
)

export default component.exports